<template>
    <v-content>
        <div v-if="!isLoading">
            <vue-page-transition name="fade-in-left">
                <router-view/>
            </vue-page-transition>
        </div>
        <OverlayLoader :show="isLoading"></OverlayLoader>
    </v-content>
</template>

<script>
    import OverlayLoader from '@/app/shared/components/app-loader/Loader';

    export default {
        name: 'Panel',
        components: {
            OverlayLoader,
        },
        beforeRouteEnter(to, from, next) {
            const route = to.path == '/admin'
                ? '/admin/offers'
                : undefined;
            next(route);
        },
        beforeRouteUpdate(to, from, next) {
            const route = to.path == '/admin'
                ? '/admin/offers'
                : undefined;
            next(route);
        },
        beforeCreate() {
            const query = Object.assign({}, this.$route.query);
            delete query.token;
            delete query.api_key;
            this.$router.replace({query});
            this.$store.dispatch('GET_AUTH_USER').catch(() => {
                this.$router.push({path: '/login'});
                this.$store.dispatch('LOGOUT');
            });
        },
        computed: {
            isLoading() {
                return this.$store.getters.AUTH_IS_LOADING;
            },
        },
    };
</script>
